module.exports = __webpack_public_path__ + "img/tiny_logo.bb8e12d6.png";